<template>
    <div :class="className" :style="{height:height,width:width}">
        <div id="ConventionChart" style="height: 400px">

        </div>
    </div>
</template>

<script>
    import echarts from 'echarts'

    require('echarts/theme/macarons') // echarts theme
    import resize from './mixins/resize'

    const animationDuration = 6000

    export default {
        mixins: [resize],
        props: {
            className: {
                type: String,
                default: 'chart'
            },
            width: {
                type: String,
                default: '100%'
            },
            height: {
                type: String,
                default: '300px'
            },
            echartdata: {
                // type: Object,
                default: {}
            }
        },
        data() {
            return {
                chart: null
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.initChart()
            })
        },
        beforeDestroy() {
            if (!this.chart) {
                return
            }
            this.chart.dispose()
            this.chart = null
        },
        methods: {
            init() {
                console.log('init')
                let div = document.getElementById("ConventionChart");
                div.innerHTML = ''

            },
            initChart() {
                // this.chart = echarts.init(this.$el, 'macarons')
                // console.log(this.echartdata)
                let list = this.echartdata

                let div = document.getElementById("ConventionChart");
                div.innerHTML = ''


                for (let i = 0; i < list.length; i++) {
                    var ch = document.createElement("div");

                    //  饼图单独处理
                    if(list[i].series.type==='pie'){
                        ch.setAttribute("class", "ChartAll pieChart");
                    }else {
                        ch.setAttribute("class", "ChartAll");
                    }

                    div.appendChild(ch);
                    let ch0 = document.createElement("div");
                    ch0.setAttribute("id", "VOCChars" + i);
                    ch0.setAttribute("class", "div-inline4");
                    ch.appendChild(ch0);

                    let Charts = echarts.init(document.getElementById('VOCChars' + i));


                    Charts.setOption(list[i]);
                }
            },

        },
    }
</script>
<style>
    .div-inline4 {
        height: 400px;
        text-align: center;
    }
    .pieChart{
        width: 500px;
        margin: 0 auto;
    }
</style>
